import * as React from "react";
import PropTypes from "prop-types";
import Layout from "../components/DefaultLayout";
import Header from "../components/Header";
import styled from "styled-components";
import { withTranslation } from "react-i18next";
import ReactGA from "react-ga";
import moment from "moment";

const Wrapper = styled.div`
  padding-bottom: 100%;
  height: 100%;
  overflow: hidden;
`;

const WrappedIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const LOGGERS_OBJ = [
  { sources: ["smav2"], target: "SMA - Webbox/IM/CC Sunnyportal" },
  { sources: ["smaApi"], target: "SMA - Ennexos" },
  { sources: ["solaredge"], target: "SolarEdge - One/Monitoring" },
  { sources: ["fronius"], target: "Fronius - SolarWeb" },
  { sources: ["weblog", "blulogXM"], target: "Meteocontrol Web'log/Blu'log" },
  { sources: ["fusion", "smartPVMS"], target: "Huawei - PVMS/Fusion" },
  { sources: ["sungrow"], target: "Sungrow - iSolarCloud" },
  { sources: ["goodwe"], target: "Goodwe - Sems" },
];

const BASE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSeBZv93DKlgcJOI3tAETM4D2zrRBHmV3KV2ZMW6VRbSusnynA/viewform?usp=pp_url";

const createFormUrl = (userData, userExtra, orgData, system) => {
  const orgParam = orgData.name
    ? "&entry.1613529438=" + encodeURIComponent(orgData.name)
    : "";

  const nameParam = "&entry.1405609066=" + encodeURIComponent(userExtra.name);

  const phoneParam = "&entry.105002036=" + encodeURIComponent(userExtra.phone);

  const email =
    userData.email && userData.emailVerified
      ? userData.email
      : userExtra.email || null;
  const emailParam = email
    ? "&entry.2005041957=" + encodeURIComponent(email)
    : "";

  const usageAgreementEncoded = encodeURI(
    "מאשר תנאי שימוש".replaceAll(" ", "+")
  );
  const contactAgreementEncoded = encodeURI(
    "מאשר את הפרטים לעיל לצרכי יצירת קשר".replaceAll(" ", "+")
  );
  const emailUpdateAgreementEncoded = encodeURI(
    "מעוניין לקבל עדכונים במייל".replaceAll(" ", "+")
  );

  const trackerEncoded = encodeURI("טראקר".replaceAll(" ", "+"));

  const autoCleanEncoded = encodeURI("שטיפה אוטומטית".replaceAll(" ", "+"));

  const checkboxesParam =
    `&entry.559975275=${usageAgreementEncoded}` +
    `&entry.559975275=${contactAgreementEncoded}` +
    `&entry.559975275=${emailUpdateAgreementEncoded}`;

  const updateDateParam = `&entry.1275542100=${moment().format("YYYY-MM-DD")}`;

  const sysNameParam = system.name
    ? "&entry.784286538=" + encodeURIComponent(system.name)
    : "";

  const installationDateParam = system.date_installed
    ? "&entry.1905372605=" + system.date_installed
    : "";

  const systemSizeParam = system.acSize
    ? "&entry.2078255916=" + system.acSize
    : "";

  const dcSizeParam = system.power ? "&entry.1864446136=" + system.power : "";

  const locationParam = system.coordinates
    ? "&entry.2075784011=" +
      system.coordinates.lat +
      ",+" +
      system.coordinates.lon
    : "";

  const trackerParam = system.tracker
    ? "&entry.951401782=" + trackerEncoded
    : "";

  const autoCleanParam = system.autoClean
    ? "&entry.951401782=" + autoCleanEncoded
    : "";

  let loggerParam = "";
  if (system.logger) {
    const logger = LOGGERS_OBJ.find((obj) =>
      obj.sources.includes(system.logger)
    );
    loggerParam = logger
      ? "&entry.1463303435=" + logger.target.replaceAll(" ", "+")
      : "";
  }

  const embeddedParam = "&embedded=true";

  const url =
    BASE_FORM_URL +
    updateDateParam +
    orgParam +
    nameParam +
    phoneParam +
    emailParam +
    checkboxesParam +
    sysNameParam +
    dcSizeParam +
    installationDateParam +
    systemSizeParam +
    loggerParam +
    trackerParam +
    autoCleanParam +
    locationParam +
    embeddedParam;

  return url;
};

class RegisterSystemPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (process.env.REACT_APP_ENV === "production") {
      ReactGA.pageview("/about");
    }
  }

  renderHeader() {
    return (
      <Header
        text="System form"
        userName={this.props.userExtra.name}
        userRole={this.props.userExtra.role}
        orgName={this.props.orgData ? this.props.orgData.name : "NA"}
        orgIsEnabled={this.props.orgData ? this.props.orgData.isEnabled : false}
      />
    );
  }

  renderContent() {
    const t = this.props.t;
    const { system } = this.props.location.state;
    return (
      <Wrapper>
        <WrappedIFrame
          src={createFormUrl(
            this.props.userData,
            this.props.userExtra,
            this.props.orgData,
            system
          )}
          // position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
        >
          {t("Loading")}
        </WrappedIFrame>
      </Wrapper>
    );
  }

  render() {
    return <Layout header={this.renderHeader()} body={this.renderContent()} />;
  }
}

RegisterSystemPage.propTypes = {
  userData: PropTypes.object,
  userExtra: PropTypes.object,
  orgData: PropTypes.object,
};

export default withTranslation()(RegisterSystemPage);
